/* ============================================================
   PREMIUM PRODUCT — gallery, zoom, lightbox, AI hotspots,
   sticky add-to-cart, quantity, bundle upsell
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     GALLERY
     ============================================================ */
  function initGallery(root) {
    if (!root || root.dataset.pmReady) return;
    root.dataset.pmReady = '1';

    var stage  = $('.pm-gallery__stage', root);
    var slides = $$('.pm-gallery__slide', root);
    var thumbs = $$('.pm-gallery__thumb', root);
    if (!stage || !slides.length) return;

    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

    function go(i, focusThumb) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      index = i;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
        // pause any video leaving the stage
        var v = s.querySelector('video');
        if (v && n !== i && !v.paused) v.pause();
      });
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        if (n === i && focusThumb && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      // Lazy-promote the neighbouring slide's image so the next click is instant
      [i + 1, i - 1].forEach(function (n) {
        var s = slides[(n + slides.length) % slides.length];
        var img = s && s.querySelector('img[loading="lazy"]');
        if (img) img.setAttribute('loading', 'eager');
      });
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { go(n); });
    });
    $$('[data-pm-gallery-prev]', root).forEach(function (b) {
      b.addEventListener('click', function () { go(index - 1, true); });
    });
    $$('[data-pm-gallery-next]', root).forEach(function (b) {
      b.addEventListener('click', function () { go(index + 1, true); });
    });

    // Keyboard on the thumbnail rail
    var rail = $('.pm-gallery__thumbs', root);
    if (rail) {
      rail.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); thumbs[index].focus(); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); go(index - 1, true); thumbs[index].focus(); }
      });
    }

    // Swipe
    var sx = 0, sy = 0, swiping = false;
    stage.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    /* --- cursor-follow zoom (desktop, pointer only) --- */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !REDUCED) {
      stage.addEventListener('mouseenter', function () {
        if (!$('.is-active img', stage)) return;
        stage.classList.add('is-zoomed');
      });
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('is-zoomed')) return;
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--pm-zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--pm-zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoomed'); });
    }

    /* --- lightbox --- */
    var lb = $('.pm-lightbox');
    if (lb) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('.pm-hotspot, .pm-gallery__arrow, .pm-gallery__ai-toggle')) return;
        var img = $('.is-active img', stage);
        if (!img) return;
        var big = lb.querySelector('img');
        if (big) {
          big.src = img.dataset.zoomSrc || img.currentSrc || img.src;
          big.alt = img.alt || '';
        }
        if (window.PremiumTheme) window.PremiumTheme.openModal(lb);
      });
    }

    /* --- AI visibility hotspots --- */
    var aiToggle = $('.pm-gallery__ai-toggle', root);
    if (aiToggle) {
      aiToggle.addEventListener('click', function () {
        var on = stage.classList.toggle('is-ai');
        aiToggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    go(index);
  }

  /* ============================================================
     STICKY ADD TO CART
     ============================================================ */
  function initStickyAtc() {
    var bar = $('.pm-sticky-atc');
    var anchor = $('[data-pm-atc-anchor]');
    if (!bar || !anchor) return;
    document.body.classList.add('pm-has-sticky-atc');

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-in', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ============================================================
     QUANTITY STEPPERS
     ============================================================ */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pm-qty]');
      if (!btn) return;
      var wrap = btn.closest('.pm-qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var step = parseInt(input.step || '1', 10) || 1;
      var min = parseInt(input.min || '1', 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var val = parseInt(input.value || min, 10) || min;
      val += (btn.dataset.pmQty === 'up' ? step : -step);
      input.value = Math.min(max, Math.max(min, val));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ============================================================
     BUNDLE / CROSS-SELL — add several variants in one request
     ============================================================ */
  function initBundle() {
    $$('[data-pm-bundle]').forEach(function (bundle) {
      if (bundle.dataset.pmReady) return;
      bundle.dataset.pmReady = '1';

      var checks = $$('input[type="checkbox"][data-variant-id]', bundle);
      var totalEl = $('[data-pm-bundle-total]', bundle);
      var btn = $('[data-pm-bundle-add]', bundle);

      function recalc() {
        var sum = 0, n = 0;
        checks.forEach(function (c) {
          if (c.checked) { sum += parseInt(c.dataset.price || '0', 10); n++; }
        });
        if (totalEl) totalEl.textContent = window.PremiumTheme.money(sum);
        if (btn) {
          btn.disabled = n === 0;
          var lbl = btn.querySelector('[data-pm-bundle-label]');
          if (lbl) lbl.textContent = (btn.dataset.labelTemplate || 'Add {n} items').replace('{n}', n);
        }
      }
      checks.forEach(function (c) { c.addEventListener('change', recalc); });
      recalc();

      if (btn) {
        btn.addEventListener('click', function () {
          var items = checks.filter(function (c) { return c.checked; }).map(function (c) {
            return { id: parseInt(c.dataset.variantId, 10), quantity: 1 };
          });
          if (!items.length) return;
          btn.disabled = true;
          btn.classList.add('is-loading');

          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error((res.data && res.data.description) || 'Cart error');
              window.PremiumTheme.toast(btn.dataset.msgSuccess || 'Added to your bag');
              document.dispatchEvent(new CustomEvent('pm:cart:updated'));
              // Refresh Dawn's cart drawer / bubble if present
              if (typeof window.fetchCart === 'function') window.fetchCart();
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble) {
                fetch(window.location.pathname + '?section_id=cart-icon-bubble')
                  .then(function (r) { return r.text(); })
                  .then(function (html) {
                    var doc = new DOMParser().parseFromString(html, 'text/html');
                    var next = doc.getElementById('cart-icon-bubble');
                    if (next) bubble.innerHTML = next.innerHTML;
                  }).catch(function () {});
              }
            })
            .catch(function (err) {
              window.PremiumTheme.toast(err.message || 'Something went wrong', { duration: 4200 });
            })
            .finally(function () {
              btn.disabled = false;
              btn.classList.remove('is-loading');
              recalc();
            });
        });
      }
    });
  }

  /* ============================================================
     COMPLETE-THE-LOOK / recently viewed
     ============================================================ */
  var RV_KEY = 'pm_recently_viewed_v1';
  function trackRecentlyViewed() {
    var meta = $('[data-pm-product-meta]');
    if (!meta) return;
    var item;
    try { item = JSON.parse(meta.textContent); } catch (e) { return; }
    if (!item || !item.id) return;
    var list = window.PremiumTheme.store(RV_KEY) || [];
    list = [item].concat(list.filter(function (x) { return String(x.id) !== String(item.id); })).slice(0, 12);
    window.PremiumTheme.store(RV_KEY, list);
  }

  function renderRecentlyViewed() {
    var host = $('[data-pm-recently-viewed]');
    if (!host) return;
    var currentId = host.dataset.excludeId || '';
    var list = (window.PremiumTheme.store(RV_KEY) || []).filter(function (x) {
      return String(x.id) !== String(currentId);
    }).slice(0, parseInt(host.dataset.limit || '6', 10));

    if (!list.length) { host.closest('[data-pm-rv-section]') && (host.closest('[data-pm-rv-section]').hidden = true); return; }

    host.innerHTML = list.map(function (p) {
      return '<article class="pm-pcard pm-card" style="border:0;background:transparent">' +
        '<a class="pm-pcard__media pm-media--3x4" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" decoding="async" width="300" height="400">' : '') +
        '</a>' +
        '<div class="pm-pcard__body">' +
          '<h3 class="pm-pcard__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<div class="pm-pcard__price">' + (p.price || '') + '</div>' +
        '</div></article>';
    }).join('');
    var sec = host.closest('[data-pm-rv-section]');
    if (sec) sec.hidden = false;
    document.dispatchEvent(new CustomEvent('pm:rendered', { detail: { root: host } }));
  }

  /* ---------- boot ---------- */
  function boot() {
    $$('.pm-gallery').forEach(initGallery);
    initStickyAtc();
    initQty();
    initBundle();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ============================================================
   VARIANT PICKER + STICKY ADD TO BAG
   Reads the variant JSON embedded by pm-product.liquid, keeps
   the hidden id, price, availability and URL in sync, and marks
   option values that cannot be reached as unavailable.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    return (window.PremiumTheme && window.PremiumTheme.money)
      ? window.PremiumTheme.money(cents)
      : (cents / 100).toFixed(2);
  }

  function init() {
    var section = $('[data-pm-section-id]');
    var dataEl = $('[data-pm-variants]');
    if (!section || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput = $('[data-pm-variant-id]', section);
    var priceEl = $('[data-pm-price]', section);
    var atcBtn = $('[data-pm-atc]', section);
    var atcLabel = $('[data-pm-atc-label]', section);
    var stickyPrice = $('[data-pm-sticky-price]');
    var radios = $$('[data-pm-option]', section);
    if (!radios.length) return;

    var soldOutText = (atcBtn && atcBtn.dataset.soldOut) || 'Sold out';

    function selected() {
      var out = [];
      radios.forEach(function (r) {
        if (!r.checked) return;
        out[parseInt(r.dataset.pmOption, 10) - 1] = r.value;
      });
      return out;
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (val, i) {
          return val === undefined || v.options[i] === val;
        });
      })[0] || null;
    }

    /* Grey out option values that cannot be combined with the rest */
    function markAvailability(opts) {
      radios.forEach(function (r) {
        var pos = parseInt(r.dataset.pmOption, 10) - 1;
        var trial = opts.slice();
        trial[pos] = r.value;
        var match = variants.filter(function (v) {
          return trial.every(function (val, i) { return val === undefined || v.options[i] === val; });
        });
        var reachable = match.some(function (v) { return v.available; });
        r.disabled = !reachable;
      });
    }

    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) return;

      if (idInput) idInput.value = v.id;

      if (priceEl) {
        var html = money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<del>' + money(v.compare_at_price) + '</del>';
        }
        priceEl.innerHTML = html;
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);

      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel) {
          if (!v.available) {
            atcLabel.textContent = soldOutText;
          } else {
            var base = atcBtn.dataset.addLabel || (atcLabel.dataset.base || '');
            if (!atcLabel.dataset.base) {
              atcLabel.dataset.base = atcLabel.textContent.split('—')[0].trim();
              base = atcLabel.dataset.base;
            }
            var showPrice = atcLabel.querySelector ? true : false;
            atcLabel.innerHTML = base + ' — <span data-pm-atc-price>' + money(v.price) + '</span>';
          }
        }
      }

      // Keep the URL shareable without reloading
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      document.dispatchEvent(new CustomEvent('pm:variant:change', { detail: { variant: v } }));
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  function initStickyAdd() {
    var sticky = $('[data-pm-sticky-add]');
    var form = $('#pm-product-form') || $('.pm-product-form');
    if (!sticky || !form) return;
    sticky.addEventListener('click', function () {
      var submit = form.querySelector('[data-pm-atc]');
      if (submit && !submit.disabled) submit.click();
    });
  }

  function boot() { init(); initStickyAdd(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ============================================================
   PDP GALLERY (pm-pgal) — big stage + side rail + thumbnails,
   cursor zoom, swipe and lightbox.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.pmPgalReady) return;
    root.dataset.pmPgalReady = '1';

    var stage = $('[data-pm-pgal-stage]', root);
    var slides = $$('[data-pm-pgal-slide]', root);
    var thumbs = $$('.pm-pgal__thumb', root);
    if (!stage || !slides.length) return;

    var index = 0;

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      index = i;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
        var v = s.querySelector('video');
        if (v && n !== i && !v.paused) v.pause();
      });
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      // Promote neighbours so the next click paints instantly
      [i + 1, i - 1].forEach(function (n) {
        var s = slides[(n + slides.length) % slides.length];
        var img = s && s.querySelector('img[loading="lazy"]');
        if (img) img.setAttribute('loading', 'eager');
      });
    }

    $$('[data-pm-pgal-go]', root).forEach(function (b) {
      b.addEventListener('click', function () { go(parseInt(b.dataset.pmPgalGo, 10) || 0); });
    });
    $$('[data-pm-pgal-prev]', root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); go(index - 1); });
    });
    $$('[data-pm-pgal-next]', root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); go(index + 1); });
    });

    /* swipe */
    var sx = 0, sy = 0, swiping = false;
    stage.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* cursor-follow zoom, pointer devices only */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !REDUCED) {
      stage.addEventListener('mouseenter', function () {
        if ($('.is-active img', stage)) stage.classList.add('is-zoomed');
      });
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('is-zoomed')) return;
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--pm-zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--pm-zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoomed'); });
    }

    /* lightbox */
    var lb = $('.pm-lightbox');
    function openLightbox() {
      var img = $('.is-active img', stage);
      if (!img || !lb) return;
      var big = lb.querySelector('img');
      if (big) {
        big.src = img.dataset.zoomSrc || img.currentSrc || img.src;
        big.alt = img.alt || '';
      }
      if (window.PremiumTheme) window.PremiumTheme.openModal(lb);
    }
    stage.addEventListener('click', function (e) {
      if (e.target.closest('button')) return;
      openLightbox();
    });
    $$('[data-pm-pgal-zoom]', root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); openLightbox(); });
    });

    go(0);
  }

  function boot() { $$('[data-pm-pgal]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
